import styled, {css} from "styled-components"

import {Card} from "@irati/ui/src/Layout"

export const BusinessLogo = styled.img`
  ${({theme}) => css`
    margin-top: ${theme.spacing.two};
    margin-bottom: ${theme.spacing.two};
    max-width: 250px;
    max-height: 100px;
    ${theme.mediaQueries.maxWidthMedia.tablet`
      max-width: 150px;
      max-height: 50px;
    `}
  `}
`

export const StyledCard = styled(Card)`
  cursor: pointer;
`
